export const messages = {
  filter: {
    showfilter: {
      id: 'filter.ShowFilter',
      defaultMessage: 'Show Filters',
    },
    hidefilter: {
      id: 'filter.HideFilter',
      defaultMessage: 'Hide Filters',
    },
    date: {
      id: 'filter.Date',
      defaultMessage: 'Date',
    },
    filterMessage: {
      id: 'filter.FilterMessage',
      defaultMessage: 'Showing {filteredRows} of {allRows}{rowItemName}',
    },
    clearFilter: {
      id: 'filter.ClearFilter',
      defaultMessage: 'Clear Filters',
    },
  },
};
